
    import * as React from 'react';

    const Chat20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Chat_20_svg__Icons/Chat/20" stroke="none" strokeWidth={1} fillRule="evenodd"><path d="M2,3 L18,3 L18,15 L11,15 L6,18 L6,15 L2,15 L2,3 Z M3,4 L3,14 L7,14 L7,16.2338096 L10.723016,14 L17,14 L17,4 L3,4 Z" id="Chat_20_svg__Rectangle" fillRule="nonzero" /></g></svg>
        </div>
      );
    };

    Chat20.displayName = 'Chat20';

    export default Chat20;
  